import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import { useAuthActions, useAuthState } from "use-eazy-auth";

export function Login() {
  const { loginLoading, loginError } = useAuthState();
  const { login, clearLoginError } = useAuthActions();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div
      style={{ height: "100vh" }}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <Form
        style={{ width: 350 }}
        className="mx-auto"
        onSubmit={(e) => {
          e.preventDefault();
          if (username !== "" && password !== "") {
            login({ username, password });
          }
        }}
      >
        <div className="mb-5 text-center">
          <h1 style={{ fontSize: "1.6rem" }}>Oratorio Brembate</h1>
          <h2 style={{ fontSize: "1.3rem" }}>Pianificazione CRE</h2>
        </div>
        <Form.Group>
          <Form.Label className="small">Username</Form.Label>
          <Form.Control
            type="text"
            value={username}
            onChange={(e) => {
              clearLoginError();
              setUsername(e.target.value);
            }}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label className="small">Password</Form.Label>
          <Form.Control
            placeholder="password"
            type="password"
            value={password}
            onChange={(e) => {
              clearLoginError();
              setPassword(e.target.value);
            }}
          />
        </Form.Group>
        <Button
          type="submit"
          variant="primary"
          disabled={loginLoading}
          block
          className="mt-5"
        >
          {!loginLoading ? "Login" : "Accesso in corso"}
        </Button>
        {loginError && (
          <Alert variant="danger" className="mt-4">
            Username/password errati
          </Alert>
        )}
        {!loginError && (
          <Alert variant="danger" className="mt-4 invisible">
            Username/password errati
          </Alert>
        )}
      </Form>
    </div>
  );
}
